import { Layout } from '@/modules/shared/layouts/layout'

import { useCustomerForm } from '../hooks/use-customer-form.hook'
import { useCustomerProfile } from '../hooks/use-customer-profile.hook'
import { CustomerFormInterface } from '../interfaces/customer-form.interface'

export function CustomerFormContainer() {
  const customerFormHook = useCustomerForm()
  const clientProfileHook = useCustomerProfile()

  const { customerFormJson } = customerFormHook

  return (
    <Layout
      pageTitle={`Cliente: ${customerFormJson ? customerFormJson?.idEntidade : 0}`}
      handleGoBack={customerFormHook.handleBackPage}
    >
      <CustomerFormInterface {...customerFormHook} {...clientProfileHook} />
    </Layout>
  )
}
